import ReactDOM from 'react-dom/client';
import EmbeddedAppWrapper from './EmbeddedAppWrapper';
import { GeneralConfigDTO, GeneralInfoDTO } from '@utils/interfaces';
import { initI18nLocale } from '../i18n';
import en from '../locales/en/translation.json';
import { InfoUser } from '@store/onlineBookingStore';
import { FlowModes } from '@utils/enums/FlowModes.enum';
import { IntegrationModes } from '@utils/enums/IntegrationModes.enum';

export interface Links {
  termsAndConditions?: string;
  privacyPolicy?: string;
  digitalIntakeForm?: string;
  storeLocator?: string;
  homePage?: string;
}

export interface LUXOB {
  storeNumber: string;
  providerId?: string;
  appointmentType?: string;
  brandName?: string;
  translationURL?: string;
  environmentConfig?: Record<string, string>;
  infoPractice?: GeneralInfoDTO;
  generalConfig?: GeneralConfigDTO;
  jwtToken?: string;
  basePath: string;
  infoUser?: InfoUser;
  hideHeader?: boolean;
  collapsableMobileBookingDetails?: boolean;
  appointmentId?: string;
  flowMode?: FlowModes;
  integrationMode?: IntegrationModes;
  pageCountry?: string;
  pageLanguage?: string;
  rescheduleURL?: string;
  cancelURL?: string;
  links?: Links;
  hideBackToBrandHomePage?: boolean;
  onShowTYP?: () => void;
  refid?: string;
}

class EmbeddedApp extends HTMLElement {
  connectedCallback() {
    console.log('#2 ConnectedCallback');
    window.luxOB = {
      ready: true,
      setConfigurations: async (configurations: LUXOB) => {
        console.log('#3 setConfigurations', configurations);
        window.luxOB.configurations = {
          storeNumber: configurations.storeNumber,
          providerId: configurations.providerId,
          appointmentType: configurations.appointmentType,
          brandName: configurations.brandName,
          translationURL: configurations.translationURL,
          generalConfig: configurations.generalConfig,
          infoPractice: configurations.infoPractice,
          jwtToken: configurations.jwtToken,
          basePath: configurations.basePath,
          infoUser: configurations.infoUser,
          environmentConfig: configurations.environmentConfig,
          hideHeader: configurations.hideHeader,
          collapsableMobileBookingDetails:
            configurations.collapsableMobileBookingDetails,
          appointmentId: configurations.appointmentId,
          flowMode: configurations.flowMode,
          integrationMode: configurations.integrationMode,
          pageCountry: configurations.pageCountry,
          pageLanguage: configurations.pageLanguage,
          rescheduleURL: configurations.rescheduleURL,
          cancelURL: configurations.cancelURL,
          links: configurations.links,
          onShowTYP: configurations.onShowTYP,
          hideBackToBrandHomePage: configurations.hideBackToBrandHomePage,
          refid: configurations.refid,
        };

        // Need to initialize i18n just after window.luxOB is set
        // because translations are fetched from the host store's translationURL
        await initI18nLocale({ en }, configurations.translationURL);

        // recupero prop da webComponent
        // const contentId = this.getAttribute("data-content-id");
        const mountPoint = document.createElement('div') as HTMLElement;
        mountPoint.style.height = '100%';
        mountPoint.style.width = '100%';
        this.appendChild(mountPoint);
        const root = ReactDOM.createRoot(mountPoint);
        root.render(<EmbeddedAppWrapper />);
      },
    };
  }
}

const ELEMENT_ID = 'onlinebooking-app';

if (!customElements.get(ELEMENT_ID)) {
  customElements.define(ELEMENT_ID, EmbeddedApp);
}
